import React, { type ReactNode, type PropsWithChildren, memo } from 'react';
import { styled } from '@compiled/react';
import Tooltip, { type PositionType } from '@atlaskit/tooltip';
import { ESTIMATE_FIELD_WRAPPER_TEST_ID } from '../constants';

export type Props = {
	tooltipLabel: string;
	ariaLabel: string;
	children: ReactNode;
	tooltipPosition?: PositionType;
};

const EstimateFieldWrapper = ({
	tooltipLabel,
	ariaLabel,
	children,
	tooltipPosition = 'bottom',
}: PropsWithChildren<Props>) => (
	<EstimateFieldContainer
		role="group"
		aria-label={ariaLabel}
		data-testid={ESTIMATE_FIELD_WRAPPER_TEST_ID}
	>
		<Tooltip content={tooltipLabel} position={tooltipPosition}>
			{children}
		</Tooltip>
	</EstimateFieldContainer>
);

export default memo<Props>(EstimateFieldWrapper);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EstimateFieldContainer = styled.div({
	height: '100%',
	display: 'flex',
	alignItems: 'center',
});
